import { Routes } from '@angular/router';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { HomeComponent } from './features/home/home.component';
import { LegalEntityListComponent } from './features/legal-entity-list/legal-entity-list.component';
import { DocumentRepositoryComponent } from './features/document-repository/document-repository.component';
import { DocumentRepositoryContactsComponent } from './features/document-repository/document-repository-contacts.component';
import { SignatoryListComponent } from './features/signatory-list/signatory-list.component';
import { SupportComponent } from './features/support/support.component';
import { AccessDeniedComponent } from './core/auth/pages/access-denied/access-denied.component';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { AuditTrailGuard } from './core/auth/guards/audit-trail.guard';

export const routes: Routes = [
  { path: 'access-denied', component: AccessDeniedComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'legal-entity-list', component: LegalEntityListComponent, canActivate: [AuthGuard] },
  {
    path: 'document-repository',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: DocumentRepositoryComponent },
      { path: ':documentSlug/contacts', component: DocumentRepositoryContactsComponent },
    ],
  },
  {
    path: 'contracts',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/contracts/contracts.component').then(
        (module) => module.ContractsComponent,
      ),
  },
  {
    path: 'contracts/:contractId/details',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./features/contracts/contracts-details.component').then(
        (module) => module.ContractsDetailsComponent,
      ),
  },
  { path: 'signatory-list', component: SignatoryListComponent, canActivate: [AuthGuard] },
  { path: 'support', component: SupportComponent, canActivate: [AuthGuard] },
  {
    path: 'management-tool-audit-trail',
    canActivate: [AuditTrailGuard],
    loadComponent: () =>
      import('./features/management-tool-audit-trail/management-tool-audit-trail.component').then(
        (module) => module.ManagementToolAuditTrailComponent,
      ),
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '**', redirectTo: 'home' },
];
